<template>
  <QChip
    class="SAIChip text-small"
    v-bind="$attrs"
    v-on="$listeners"
    :text-color="textColor"
  />
</template>

<script>
import { QChip } from 'quasar';

export default {
  name: 'SAIChip',
  props: {
    textColor: {
      type: String,
      default: 'white'
    }
  },
  components: {
    QChip
  }
};
</script>

<style lang="sass" scoped>
.SAIChip::v-deep
  height: auto
  padding: 6px 10px

  .q-chip__content
    font-weight: 700
</style>
